import {useCallback} from "react";
import {
	SelectField,
	InputField
} from "~/components/Forms";
import {CAREERS} from "../../../../app/constants";

function CreatedWebsiteSearchBar({filter, onSearchChange, onChange}) {

	const careerOptions = [
		{ value: '', label: 'Tất cả ngành nghề' },
		...CAREERS
	];

	const handleKeywordChange = (e) => {
		if (!onSearchChange) return;
		const newFilter = {
			...filter,
			keyword: e.target.value,
			page: 1,
		};
		onSearchChange(newFilter);
	}

	const handleCareerChange = useCallback((value) => {
		if(onChange) onChange('career', value);
	}, [onChange]);

	return (
		<div className="search-bar">
			<div className="container">
				<form className="form" autoComplete="off">
					<InputField defaultValue={filter.keyword} placeholder="Đường dẫn" onChange={handleKeywordChange} />
					<SelectField placeholder="Loại" options={careerOptions} onChange={handleCareerChange}/>
				</form>
			</div>
		</div>
	)
}

export default CreatedWebsiteSearchBar;